import { render, staticRenderFns } from "./BundleModal.vue?vue&type=template&id=b2cd31bc&"
import script from "./BundleModal.vue?vue&type=script&lang=js&"
export * from "./BundleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports